import React from "react";
import { useQuery } from "@apollo/react-hooks";

import { FeaturesBenefitsPlaceholder } from "../Placeholders";
import { GET_FEATURES_BENEFITS } from "../../../../services/graphql-query";

export default function FeaturesBenefits({ collectionName }) {
    const { loading, data } = useQuery(GET_FEATURES_BENEFITS, {
        variables: { name: collectionName },
    });

    return (
        <>
            {loading ||
                (data.collections.data[0].attributes.features_benefits && (
                    <div
                        className="py-4"
                        style={{
                            borderBottom: "1px solid",
                            borderColor: "rgba(185, 215, 15)",
                        }}
                    >
                        {loading ? (
                            <FeaturesBenefitsPlaceholder />
                        ) : data.collections.data[0].attributes
                              .features_benefits ? (
                            <>
                                <h2 className="text-uppercase fw-bold">
                                    Features and benefits
                                </h2>
                                <div className="row mw-900">
                                    <div className="col-md mb-md-0 mb-3">
                                        <ul>
                                            {data.collections.data[0].attributes.features_benefits.features.map(
                                                (f) => {
                                                    return <li>{f.feature}</li>;
                                                }
                                            )}
                                        </ul>
                                    </div>
                                    <div className="col-md">
                                        <ul>
                                            {data.collections.data[0].attributes.features_benefits.benefits.map(
                                                (b) => {
                                                    return <li>{b.benefit}</li>;
                                                }
                                            )}
                                        </ul>
                                    </div>
                                </div>
                            </>
                        ) : (
                            <></>
                        )}
                    </div>
                ))}
        </>
    );
}
